import throttle from 'lodash/throttle';

export default function loadHooks() {
  const hooks = document.querySelectorAll('[data-toggle="hook"]');
  if(hooks.length > 0) {
    hooks.forEach(el => {
      const elMarginTop = parseInt(getComputedStyle(el).getPropertyValue('margin-top'));
      const elPos = el.getBoundingClientRect().top + window.scrollY - elMarginTop;
      const elWidth = window.getComputedStyle(el).getPropertyValue('width');
      const throttled = throttle(hookElement.bind(this, el, elPos, elMarginTop, elWidth), 80);
      window.addEventListener('scroll', throttled);
      hookElement(el, elPos, elMarginTop, elWidth);
    });
  }
}

function hookElement(el, pos, marginTop, width) {
  if(window.scrollY >= pos) {
    el.style.width = width;
    el.style.marginTop = 0;
    el.style.top = marginTop > 0 ? marginTop + 'px' : '32px';
    el.classList.add('js-is--hooked');
  } else if(window.scrollY <= pos) {
    el.style.width = 'auto';
    el.style.marginTop = marginTop + 'px';
    el.style.top = 'auto';
    el.classList.remove('js-is--hooked');
  }
}
